import {buildQueryParams, baseUrl} from './Requests';

function getForm4(ticker, reporter = null) {
  const queryParams = {
    "ticker": ticker,
  };

  // reporter가 제공되면 쿼리에 추가
  if (reporter) {
    queryParams["reporter"] = reporter;
  }

  const params = buildQueryParams(queryParams);
  const url = `${baseUrl}/form4/ticker?${params.toString()}`;
  const response = fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  })
  return response;
}

export {getForm4}


function getForm4General(ticker, size, datefrom, dateto) {
  const queryParams = {
    size: size,
    page: 1,
    limit: 1
  };

  if (ticker && ticker !== 'None') {
    queryParams.ticker = ticker;
  }
  if (datefrom) {
    queryParams.datefrom = datefrom;
  }
  if (dateto) {
    queryParams.dateto = dateto;
  }

  const params = buildQueryParams(queryParams);

  return (
    fetch(`${baseUrl}/form4?${params.toString()}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
    })
  )

}
export {getForm4General}